import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.cardBg ?? theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 1px 3px ${({ theme }) => theme.colors.cardShadow};
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
  flex-shrink: 0;
`;

export const ContentSection = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) clamp(300px, 22vw, 360px);
  gap: 16px;
  flex: 1;
  min-height: 0;
  padding: 16px 24px 24px;
  overflow: visible;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }

  @media (min-width: 1400px) and (min-height: 850px) {
    align-items: stretch;
  }
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  gap: 10px;
  overflow: hidden;
`;


export const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  align-self: stretch;
  padding-bottom: 8px;
`;

export const HeaderTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 12px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
`;

export const BackButton = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.dark};
  flex-shrink: 0;
  transition: border-color 0.15s, color 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
  }
`;


export const GroupNameBadge = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 400;
`;

export const TabsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;

  .ant-tabs { flex: 1; min-width: 0; }
  .ant-tabs-nav { margin-bottom: 0 !important; }
  .ant-tabs-nav::before { border-bottom: none !important; }
  .ant-tabs-tab .ant-tabs-tab-btn { font-size: 16px; font-weight: 500; }

  @media (max-width: 1100px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SelectControlWrapper = styled.div`
  width: ${({ $width }) => $width || "240px"};
  flex-shrink: 0;

  .ant-select { width: 100%; }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ViewByRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;


export const SubmitButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  height: 36px;
  padding: 0 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  transition: background 0.15s, opacity 0.15s;
  background: ${({ $disabled, theme }) => ($disabled ? theme.colors.primaryDisabled : theme.colors.primary)};
  color: ${({ theme }) => theme.colors.white};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  opacity: ${({ $disabled }) => ($disabled ? 0.75 : 1)};

  &:hover {
    background: ${({ $disabled, theme }) => ($disabled ? theme.colors.primaryDisabled : theme.colors.primaryHover)};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  background: ${({ theme }) => theme.colors.white};
  overflow-y: auto;  // ✅ Enable scrolling
  position: relative;
`;



export const StatsCardContainer = styled.div`
  width: 100%;
  min-width: 0;
  min-height: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  flex: ${({ $scrollable }) => ($scrollable ? "1" : "0 0 auto")};
  overflow: hidden;

  .paic-stats-card {
    width: 100%;
    height: ${({ $scrollable }) => ($scrollable ? "100%" : "auto")};
    display: flex;
    flex-direction: column;
    min-height: 0;
    box-shadow: 0 4px 12px ${({ theme }) => theme.colors.cardShadow} !important;
  }

  .paic-stats-card .ant-card-head {
    min-height: auto !important;
    padding: 0 !important;
    background: ${({ theme }) => theme.colors.primary};
    flex-shrink: 0;
  }

  .paic-stats-card .ant-card-head-title {
    padding: 0 !important;
    white-space: normal !important;
  }

  .paic-stats-card .ant-card-body {
    padding: clamp(12px, 1vw, 16px) !important;
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
    min-height: 0;
    overflow-y: ${({ $scrollable }) => ($scrollable ? "auto" : "visible")} !important;
  }
`;

export const StatsCardHeader = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: 0.875rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const StatsCardTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.2;
`;

export const StatsCardSubtitle = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.white};
  line-height: 1.2;
`;

export const StatsCardBody = styled.div`
  display: flex;
  flex-direction: column;
  
  
  > * {
    padding: 8px 0;
  }
  
  > *:first-child {
    padding-top: 0;
  }
  
  > *:last-child {
    padding-bottom: 0;
  }
`;

export const StatsBigValue = styled.div`
  font-size: 20px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.dark};
  line-height: 1.2;
  margin-bottom: 2px;
  word-break: break-word;
`;

export const StatsLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray};
`;

export const StatsRoiBadge = styled.div`
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.secondary};
  border-radius: 6px;
  padding: 0.3rem 0.7rem;
  font-size: 14px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.dark};
  white-space: nowrap;
  align-self: flex-start;
  margin-top: 2px;
`;

export const StatsTile = styled.div`
  background: ${({ theme }) => theme.colors.light};
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 8px;
  padding: 3px 2px;
  text-align: center;
  min-width: 0;
`;

export const StatsTileLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray};
  margin-bottom: 3px;
  text-transform: uppercase;
  letter-spacing: 0.2px;
`;

export const StatsTileValue = styled.div`
  font-size: 16px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.dark};
  word-break: break-word;
`;


export const TableShell = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-width: 0;

  .paic-description-cell {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }

  .paic-clickable-row > td {
    cursor: pointer;
    transition: background-color 0.15s ease;
  }

  .paic-clickable-row:hover > td {
    background: ${({ theme }) => theme.colors.tableRowHoverBg} !important;
  }

  .paic-row-action,
  .paic-row-action * {
    cursor: pointer;
  }
`;


export const StatsPrimaryRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  flex-shrink: 0;
`;

export const StatsTileGrid3 = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  flex-shrink: 0;
`;

export const StatsTileGrid2 = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  flex-shrink: 0;
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const TabLabelWithCaret = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const SectionIntro = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;


export const TabsAndControlsBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  padding-bottom: 5px;
  min-width: 0;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const ViewByLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-wrap: wrap;
`;

export const ViewByText = styled.span`
  font-size: 18px;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  color: ${({ $active, theme }) => ($active ? theme.colors.dark : theme.colors.textLight)};
`;

// Aliases for backward compatibility
export const ViewByActiveText = ViewByText;
export const ViewByInactiveText = ViewByText;

export const SelectedAgentsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex-shrink: 0;
`;

// CSS-to-Styled-Components Migration
export const InstructionsBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const InstructionsList = styled.ol`
  margin: 0;
  padding-left: 20px;
  list-style-type: decimal;
`;

export const InstructionsItem = styled.li`
  line-height: 1.2;
  color: rgba(0, 0, 0, 0.45);
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
  line-height: 1.2;
`;

export const OptionText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.dark};
`;

export const ComingSoonText = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.gray};
  font-style: italic;
  margin: 0;
`;

export const ViewByLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.dark};
`;

export const HelperList = styled.ol`
  margin: 0;
  padding-left: 20px;
  list-style-type: decimal;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.gray};
`;

export const HelperListItem = styled.li`
  line-height: 1.4;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.gray};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const NoAgentsMsg = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray};
  font-style: italic;
  margin: 0;
  text-align: center;
`;
